import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "@/lib/toast";
import { LoginShell } from "@/pages/Login";

const MIN_LENGTH = 8;

// Aberta pelo link temporário gerado em "Usuários & Níveis" (/definir-senha#<token>).
// O token fica no fragmento (#) para não ir para logs de servidor nem no Referer
export default function DefinirSenha() {
  const nav = useNavigate();
  const [token] = useState(() => window.location.hash.replace(/^#/, ""));
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!token) { setError("Link inválido. Peça um novo link abaixo ou ao gestor."); return; }
    api.post("/auth/password-link", { token }).then(({ data }) => setInfo(data)).catch((err) => setError(err.message));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < MIN_LENGTH) return toast.error(`A senha deve ter pelo menos ${MIN_LENGTH} caracteres`);
    if (password !== confirm) return toast.error("As senhas não conferem");
    setSaving(true);
    try {
      await api.post("/auth/password", { token, password });
      toast.success("Senha definida. Entre com seu e-mail e a nova senha.");
      nav(`/login?email=${encodeURIComponent(info.email)}`, { replace: true });
    } catch (err) {
      toast.error(err.message);
      setSaving(false);
    }
  };

  return (
    <LoginShell>
      <div className="card">
        <div className="card-body login-card-body">
          {error ? (
            <>
              <p className="login-box-msg text-danger" data-testid="set-password-error"><i className="fas fa-exclamation-triangle mr-1" />{error}</p>
              <Link to="/esqueci-senha" className="btn btn-primary btn-block" data-testid="set-password-request-new">Pedir um novo link</Link>
              <Link to="/login" className="btn btn-default btn-block">Ir para o login</Link>
            </>
          ) : !info ? (
            <p className="login-box-msg"><i className="fas fa-spinner fa-spin mr-1" />Verificando link...</p>
          ) : (
            <>
              <p className="login-box-msg">Olá, <b>{info.name}</b>. Defina sua senha de acesso.</p>
              <form onSubmit={submit} data-testid="set-password-form">
                <div className="input-group mb-3">
                  <input type="email" className="form-control" value={info.email} autoComplete="username" readOnly />
                  <div className="input-group-append"><div className="input-group-text"><span className="fas fa-envelope" /></div></div>
                </div>
                <div className="input-group mb-3">
                  <input data-testid="set-password-input" type="password" className="form-control" placeholder={`Nova senha (mín. ${MIN_LENGTH} caracteres)`} autoComplete="new-password" required minLength={MIN_LENGTH} autoFocus
                    value={password} onChange={(e) => setPassword(e.target.value)} />
                  <div className="input-group-append"><div className="input-group-text"><span className="fas fa-lock" /></div></div>
                </div>
                <div className="input-group mb-3">
                  <input data-testid="set-password-confirm-input" type="password" className="form-control" placeholder="Confirme a senha" autoComplete="new-password" required
                    value={confirm} onChange={(e) => setConfirm(e.target.value)} />
                  <div className="input-group-append"><div className="input-group-text"><span className="fas fa-lock" /></div></div>
                </div>
                <button data-testid="set-password-submit" type="submit" className="btn btn-primary btn-block" disabled={saving}>
                  {saving && <i className="fas fa-spinner fa-spin mr-1" />}Definir senha
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </LoginShell>
  );
}
